<template>
  <v-dialog v-model="dialog" :max-width="options.width" @keyup.esc="cancel" :persistent="block" style="z-index: 2000">
    <v-card v-if="typeContact" class="roundedCard">
      <v-card-text v-show="!!message" class="subtitle-1 pa-4 text-center">
        <div class="pb-7 pt-2">
          <icon name="icon-check-list" width="61" height="68" />
        </div>
        {{ message }}
      </v-card-text>
      <v-card-actions class="flex-column py-8">
        <v-btn
          type="submit"
          color="primary"
          class="rounded-lg py-5 px-7"
          @click="confirm"
        >
          {{ $gettext('Back to home') }}
        </v-btn>
        <v-spacer></v-spacer>
      </v-card-actions>
    </v-card>
    <v-card v-else>
      <v-toolbar :color="options.color" dense flat>
        <v-toolbar-title class="white--text">{{ title }}</v-toolbar-title>
      </v-toolbar>
      <v-card-text v-show="!!message" class="subtitle-1 pa-4">{{ message }}</v-card-text>
      <v-card-actions class="pt-0" v-if="isAlert">
        <v-btn
          type="submit"
          color="primary"
          class="font-weight-bold elevation-0"
          @click="confirm"
        >
          {{ $gettext('Close') }}
        </v-btn>
        <v-spacer></v-spacer>
      </v-card-actions>
      <v-card-actions class="pt-0" v-else>
        <v-btn
          type="submit"
          color="primary"
          class="font-weight-bold elevation-0"
          @click="confirm"
        >
          {{ $gettext('Confirm') }}
        </v-btn>
        <v-btn
          text
          class="font-weight-bold mr-3"
          @click="cancel"
        >
          {{ $gettext('Cancel') }}
        </v-btn>
        <v-spacer></v-spacer>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "Confirm",
  data() {
    return {
      dialog: false,
      resolve: null,
      message: null,
      title: null,
      isAlert: false,
      options: {
        color: "primary",
        width: 300
      },
      block: false,
      typeContact: false
    };
  },
  methods: {
    open(title, message, options, isAlert = false, block = false, typeContact = false) {
      this.dialog = true;
      this.title = title;
      this.message = message;
      this.options = Object.assign(this.options, options);
      this.isAlert = isAlert
      this.block = block
      this.typeContact = typeContact
      return new Promise(resolve => {
        this.resolve = resolve;
      });
    },
    cancel() {
      this.resolve(false);
      this.dialog = false;
    },
    confirm() {
      this.resolve(true);
      this.dialog = false;
    }
  }
};
</script>
